export const ReactRouteAccessKey = {
  anyAuthorized: 'anyAuthorized',
  hasPlatformRoles: 'hasPlatformRoles',
  hasEmployerRoles: 'hasEmployerRoles',
  hasVerifierRoles: 'hasVerifierRoles',
  hasPeoRoles: 'hasPeoRoles',
  isEmployee: 'isEmployee',
  isPlatformAdmin: 'isPlatformAdmin',
  isPlatformManager: 'isPlatformManager',
  isPeoPayrollProviderUser: 'isPeoPayrollProviderUser',
  isPartnershipCompanyUser: 'isPartnershipCompanyUser',
  isNotPartnershipCompanyUser: 'isNotPartnershipCompanyUser',
  inherit: 'inherit',
} as const;
export type ReactRouteAccessKey = (typeof ReactRouteAccessKey)[keyof typeof ReactRouteAccessKey];
